exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-content[data-v-25f468f8]{margin-top:60px;border-top:1px solid #c9c9c9}.footer-content .footer-group[data-v-25f468f8]{display:flex;justify-content:space-between;align-items:center;padding:20px 0;background:#e6e9ec}.footer-content .footer-group .logo img[data-v-25f468f8]{width:216px}.footer-content .footer-group .arrow-up[data-v-25f468f8]{height:50px;text-decoration:none}.footer-content .footer-group .arrow-up ion-icon[data-v-25f468f8]{color:var(--dark-gray);font-size:50px}.footer-content .footer-group .arrow-up ion-icon[data-v-25f468f8]:hover{color:#2c323b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25f468f8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/default/footerMenu.vue
// module id = 848
// module chunks = 0